interface Props {
  tableData: {key: string, value: string}[];
}

function JsonExtendedDescriptionTable(props: Props) {
  const { tableData } = props;
  return (
    <table className="table table-striped">
      <tbody>
        {tableData.map((row) => (
          <tr key={row.key}>
            <td>{row.key}</td>
            <td>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default JsonExtendedDescriptionTable;
